/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_New_User_ButtonInputs */



/**
* | output |
* | --- |
* | "New User" |
*
* @param {Team_Manager_New_User_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_new_user_button = /** @type {((inputs?: Team_Manager_New_User_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_New_User_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvel utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Benutzer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый пользователь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新規ユーザー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नए उपयोगकर्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo usuário")
	return /** @type {LocalizedString} */ ("New User")
});